import { expandRows, fromGrid, makeIcon } from './pixel';

// Desktop icons (32 x 32 grid, drawn at 64 px, two screen pixels to a cell). Rows are run-length encoded, see expandRows.
// Letters are palette keys, '.' is transparent.

const ICON = [32, 32];
const draw = rows => fromGrid(expandRows(rows));

const ABOUT = [
  '.32',
  '.32',
  '.32',
  '.32',
  '.32',
  '.32',
  '.32',
  '.32',
  '.3 K26 .3',
  '.3 K1 W1 B23 K1 .3',
  '.3 K1 B24 K1 .3',
  '.3 K1 G24 K1 .3',
  '.3 K1 G24 K1 .3',
  '.3 K1 G1 K7 G2 S12 G2 K1 .3',
  '.3 K1 G1 K1 T5 K1 G16 K1 .3',
  '.3 K1 G1 K1 T1 D3 T1 K1 G16 K1 .3',
  '.3 K1 G1 K1 T1 D3 T1 K1 G2 S9 G5 K1 .3',
  '.3 K1 G1 K1 D5 K1 G16 K1 .3',
  '.3 K1 G1 K1 D5 K1 G16 K1 .3',
  '.3 K1 G1 K1 T5 K1 G2 S11 G3 K1 .3',
  '.3 K1 G1 K7 G16 K1 .3',
  '.3 K1 G24 K1 .3',
  '.3 K1 G24 K1 .3',
  '.3 K26 .3',
  '.32',
  '.32',
  '.32',
  '.32',
  '.32',
  '.32',
  '.32',
  '.32',
];

const EXPERIENCE = [
  '.32',
  '.32',
  '.32',
  '.32',
  '.32',
  '.32',
  '.32',
  '.11 K10 .11',
  '.11 K1 .8 K1 .11',
  '.11 K1 .8 K1 .11',
  '.11 K10 .11',
  '.3 K26 .3',
  '.3 K1 W24 K1 .3',
  '.3 K1 R24 K1 .3',
  '.3 K1 R24 K1 .3',
  '.3 K1 R10 K4 R10 K1 .3',
  '.3 K1 R10 K1 Y2 K1 R10 K1 .3',
  '.3 K1 R10 K1 Y2 K1 R10 K1 .3',
  '.3 K1 R10 K4 R10 K1 .3',
  '.3 K1 S24 K1 .3',
  '.3 K1 R24 K1 .3',
  '.3 K1 R24 K1 .3',
  '.3 K1 R24 K1 .3',
  '.3 K1 R24 K1 .3',
  '.3 K1 S24 K1 .3',
  '.3 K26 .3',
  '.32',
  '.32',
  '.32',
  '.32',
  '.32',
  '.32',
];

const PROJECTS = [
  '.32',
  '.32',
  '.32',
  '.12 K14 .6',
  '.12 K1 B4 G5 B3 K1 .6',
  '.12 K1 B4 G5 B3 K1 .6',
  '.12 K1 B4 G5 B3 K1 .6',
  '.12 K1 B2 W8 B2 K1 .6',
  '.12 K1 B2 W8 B2 K1 .6',
  '.2 K28 .2',
  '.2 K1 W26 K1 .2',
  '.2 K1 Y26 K1 .2',
  '.2 K1 Y26 K1 .2',
  '.2 K1 Y26 K1 .2',
  '.2 K1 Y26 K1 .2',
  '.2 K1 Y26 K1 .2',
  '.2 K1 Y26 K1 .2',
  '.2 K1 Y26 K1 .2',
  '.2 K1 Y26 K1 .2',
  '.2 K1 Y26 K1 .2',
  '.2 K1 Y26 K1 .2',
  '.2 K1 Y26 K1 .2',
  '.2 K1 Y26 K1 .2',
  '.2 K1 Y26 K1 .2',
  '.2 K1 Y26 K1 .2',
  '.2 K1 Y26 K1 .2',
  '.2 K1 Y26 K1 .2',
  '.2 K1 D26 K1 .2',
  '.2 K28 .2',
  '.32',
  '.32',
  '.32',
];

const RESEARCH = [
  '.32',
  '.32',
  '.32',
  '.12 K8 .12',
  '.12 K1 G6 K1 .12',
  '.12 K1 G6 K1 .12',
  '.12 K1 G6 K1 .12',
  '.12 K1 G6 K1 .12',
  '.12 K1 G6 K1 .12',
  '.12 K1 G6 K1 .12',
  '.12 K1 G6 K1 .12',
  '.11 K1 G8 K1 .11',
  '.10 K1 G10 K1 .10',
  '.8 K1 G14 K1 .8',
  '.6 K1 G18 K1 .6',
  '.5 K1 G20 K1 .5',
  '.5 K1 L20 K1 .5',
  '.5 K1 L3 W2 L15 K1 .5',
  '.5 K1 L3 W2 L15 K1 .5',
  '.5 K1 L20 K1 .5',
  '.5 K1 L11 W2 L7 K1 .5',
  '.5 K1 L20 K1 .5',
  '.5 K22 .5',
  '.4 D24 .4',
  '.32',
  '.32',
  '.32',
  '.32',
  '.32',
  '.32',
  '.32',
  '.32',
];

const CONTACT = [
  '.32',
  '.32',
  '.32',
  '.32',
  '.32',
  '.32',
  '.32',
  '.32',
  '.2 K28 .2',
  '.2 K2 G24 K2 .2',
  '.2 K1 W2 K1 G20 K1 W2 K1 .2',
  '.2 K1 W4 K1 G16 K1 W4 K1 .2',
  '.2 K1 W6 K1 G12 K1 W6 K1 .2',
  '.2 K1 W8 K1 G8 K1 W8 K1 .2',
  '.2 K1 W10 K1 G4 K1 W10 K1 .2',
  '.2 K1 W12 K2 W12 K1 .2',
  '.2 K1 W26 K1 .2',
  '.2 K1 W19 K6 W1 K1 .2',
  '.2 K1 W19 K1 R4 K1 W1 K1 .2',
  '.2 K1 W19 K1 R4 K1 W1 K1 .2',
  '.2 K1 W19 K6 W1 K1 .2',
  '.2 K1 W26 K1 .2',
  '.2 K28 .2',
  '.32',
  '.32',
  '.32',
  '.32',
  '.32',
  '.32',
  '.32',
  '.32',
  '.32',
];

export const IconAbout = makeIcon('IconAbout', ICON, 64, draw(ABOUT));
export const IconExperience = makeIcon('IconExperience', ICON, 64, draw(EXPERIENCE));
export const IconProjects = makeIcon('IconProjects', ICON, 64, draw(PROJECTS));
export const IconResearch = makeIcon('IconResearch', ICON, 64, draw(RESEARCH));
export const IconContact = makeIcon('IconContact', ICON, 64, draw(CONTACT));
